import { render, staticRenderFns } from "./order-type-group-field.vue?vue&type=template&id=46492566&"
import script from "./order-type-group-field.vue?vue&type=script&lang=ts&"
export * from "./order-type-group-field.vue?vue&type=script&lang=ts&"
import style0 from "./order-type-group-field.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports